<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            class="fluid grid-list-xl"
            style="height: 100%;"
    >

        <v-layout
                class="row wrap justify-center "
                style="font-size: 15px; font-weight: bold; padding-bottom: 30px;">
            궁금한 점이나 긴급 사항이 있으실 경우 발렛팀장에게 연락 바랍니다.<br/>
            <br/>
            센터원 빌딩 발렛팀장: 정수민 팀장 (010-5096-8597)
        </v-layout>
        <v-container
                fluid
                class="pa-2 grid-list-lg"
                v-for="periodiccars_yearmonth_item in items_yearmonthday"
                :key="periodiccars_yearmonth_item.yearmonthday"
        >
            <v-layout
                    class="row wrap justify-center "
                    style="font-size: 30px; font-weight: bold; margin-top: 30px;">
                {{ periodiccars_yearmonth_item.yearmonthname }}
            </v-layout>
            <v-layout
                    class="row wrap justify-center "
                    style="font-size: 30px; font-weight: bold; "
                    v-if="periodiccars_yearmonth_item.showadd">
                <v-btn color="primary" class="ma-0" style="border-radius: 0; height: 60px; font-weight: bold; font-size: 25px;"
                       @click="edit_item_add(periodiccars_yearmonth_item);">VIP 발렛 예약</v-btn>
            </v-layout>

            <v-layout
                    class="row wrap justify-center"
                    style="margin-bottom: 20px;"
            >
                <v-flex class="xs12 sm6 md4 lg3 xl2" style="min-width: 280px; max-width: 280px;"
                        v-for="item in periodiccars_yearmonth_item.reservations"
                        :key="item.ValetReservationIDX"
                >
                    <v-tooltip top v-bind:disabled="tool_app.isAdmin() == false">
                        <template v-slot:activator="{ on }">
                            <v-card class="v-btn pa-1 periodiccarcard" v-bind:class="[item.IsPeriodicCarDeleted?'deep-orange':'white']" v-on="on">
                                <table style="width: 100%; height: 70px; background-color: transparent;" >
                                    <tr>
                                        <td style="vertical-align: center; text-align: center; color: black;">
                                            <table style="width: 100%; table-layout: fixed;">
                                                <tr>
                                                    <td style="font-weight: bold; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                                        {{item.ReservationRequesterCompany}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold; font-size: 15px; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                                        {{item.CarNumber}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                                        <!--                                                        {{tool_app.padzero(item.DateTime_Reservation_Parsed.getHours(), 2)}}:{{tool_app.padzero(item.DateTime_Reservation_Parsed.getMinutes(), 2)}}-->
                                                        {{item.DateTime_Reservation_Desc}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td style="width: 55px; padding: 5px 0px 5px 5px;" v-if="item.showmod">
                                            <v-btn color="gray" class="ma-0" outline style="border-radius: 0; height: 60px;" @click="edit_item_modify(item)">
                                                <v-icon large color="black">create</v-icon>
                                            </v-btn>
                                        </td>
                                        <td style="width: 55px; padding: 5px 0px 5px 5px;" v-if="item.showmod">
                                            <v-btn color="gray" class="ma-0" outline style="border-radius: 0; height: 60px;" @click="edit_item_delete(item)">
                                                <v-icon large color="black">delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </table>
                            </v-card>
                        </template>
                        <!--                                차량번호-->
                        <!--                                차종-->
                        <!--                                이용 예상시간-->
                        <!--                                이용 예정고객 (연락처)-->

                        <!--                                신청회사-->
                        <!--                                신청자 이름 (연락처)-->
                        <!--                                신청일-->
                        <table class="text-xs-left">
                            <tr>
                                <td>
                                    {{item.CarNumber}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{item.CarModel}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{tool_app.dateformat(item.DateTime_Reservation, 'YYYY.MM.DD HH:mm')}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{item.CarOwnerName}}<span v-show="item.CarOwnerTel">({{item.CarOwnerTel}})</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{item.ReservationRequesterCompany}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{item.ReservationRequesterName}}<span v-show="item.ReservationRequesterTel">({{item.ReservationRequesterTel}})</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{tool_app.dateformat(item.DateTime_Created, 'YYYY.MM.DD')}}
                                </td>
                            </tr>
                        </table>
                    </v-tooltip>
                </v-flex>

            </v-layout>
        </v-container>

        <v-dialog v-model="parkinglots_dialog" persistent max-width="400px">
            <v-card>
                <v-card-text>
                    <v-btn
                            v-for="parkinglot in parkinglots"
                            :key="parkinglot.ParkingLotIDX"
                            class="success"
                            @click="
                          parkinglot_selected = parkinglot;
                          $cookies.set('parkinglotidx', parkinglot_selected.ParkingLotIDX);
                          parkinglots_dialog = false; getList();"
                    >
                        {{ parkinglot.Name }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="edit_dialog" persistent max-width="600px">
            <v-card>
                <v-card-text>
                    <span style="font-weight: bold; font-size: 17px;" v-if="edit_new === true">발렛 예약 신청</span>
                    <span style="font-weight: bold; font-size: 17px;" v-if="edit_new === false">발렛 예약 수정</span>
                    <v-container grid-list-md>
                        <v-form ref="edit_form"
                                v-model="edit_valid"
                                lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field label="차량 번호"
                                                  @keydown="$event.keyCode === 32 ? $event.preventDefault() : false"
                                                  v-model="edit_item.CarNumber"
                                                  :rules="edit_carnumber_rules"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="차종"
                                                  v-model="edit_item.CarModel"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <table>
                                        <tr>
                                            <td style="text-align: right; padding-right: 20px;">
                                                {{edit_item.DateTime_Reservation_Month}}월
                                                {{edit_item.DateTime_Reservation_Date}}일
                                            </td>
                                            <!--                                            <td style="padding-right: 5px;">-->
                                            <!--                                                <v-select-->
                                            <!--                                                        :items="DateTime_Reservation_AMPM_Items"-->
                                            <!--                                                        v-model="edit_item.DateTime_Reservation_AMPM"-->
                                            <!--                                                        style="width:50px;"-->
                                            <!--                                                        :rules="edit_exist_rules"></v-select>-->
                                            <!--                                            </td>-->
                                            <td style="padding-right: 10px;">
                                                <v-select
                                                        :items="DateTime_Reservation_Hour_Items"
                                                        v-model="edit_item.DateTime_Reservation_Hour"
                                                        style="width:110px;"
                                                        item-value="value"
                                                        item-text="text"
                                                        :rules="edit_exist_rules"></v-select>
                                            </td>
                                            <!--                                            <td style="padding-right: 10px;">-->
                                            <!--                                                시-->
                                            <!--                                            </td>-->
                                            <td>
                                                <v-select
                                                        :items="DateTime_Reservation_Minute_Items"
                                                        v-model="edit_item.DateTime_Reservation_Minute"
                                                        style="width:70px;"
                                                        item-value="value"
                                                        item-text="text"></v-select>
                                            </td>
                                            <!--                                            <td>-->
                                            <!--                                                분-->
                                            <!--                                            </td>-->
                                        </tr>
                                    </table>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="이용 예정 고객 (직함도 적어주시면 의전에 참고하겠습니다.)"
                                                  v-model="edit_item.CarOwnerName"
                                                  :rules="edit_name_rules"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="이용 예정 고객 연락처"
                                                  v-model="edit_item.CarOwnerTel"
                                                  @keydown="filterNumber($event);"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="발렛 신청 회사"
                                                  v-model="edit_item.ReservationRequesterCompany"
                                                  disabled></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="발렛 신청자 이름"
                                                  v-model="edit_item.ReservationRequesterName"
                                                  disabled></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="발렛 신청자 연락처"
                                                  v-model="edit_item.ReservationRequesterTel"
                                                  @keydown="filterNumber($event);"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <!--                            <v-layout wrap v-if="edit_new === true">-->
                            <!--                                <v-flex xs6>-->
                            <!--                                    <v-select-->
                            <!--                                            :items="payment_years"-->
                            <!--                                            label="신규 결제년"-->
                            <!--                                            v-model="payment_item.PaymentYear"-->
                            <!--                                            :rules="edit_exist_rules"></v-select>-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs6>-->
                            <!--                                    <v-select-->
                            <!--                                            :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, ]"-->
                            <!--                                            label="신규 결제월"-->
                            <!--                                            v-model="payment_item.PaymentMonth"-->
                            <!--                                            :rules="edit_exist_rules"></v-select>-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs12>-->
                            <!--                                    <v-text-field label="결제금액 (VAT 포함)"-->
                            <!--                                                  v-model="payment_item.PaymentAmount"-->
                            <!--                                                  :rules="edit_exist_rules"-->
                            <!--                                    ></v-text-field>-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs12>-->
                            <!--                                    <v-text-field label="결제 업무자"-->
                            <!--                                                  v-model="payment_item.PaymentAccountName"-->
                            <!--                                                  :rules="edit_exist_rules"></v-text-field>-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs12>-->
                            <!--                                    <v-text-field label="비고"-->
                            <!--                                                  v-model="payment_item.PaymentDescription"-->
                            <!--                                    ></v-text-field>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="edit_dialog = false">취소</v-btn>
                    <v-btn color="blue darken-1" flat @click="edit_submit()" v-if="edit_new === true">신청하기</v-btn>
                    <v-btn color="blue darken-1" flat @click="edit_submit()" v-if="edit_new === false">수정하기</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<style lang="scss">
    .theme--light.v-table {
        background-color: #eeeeee;
    }
    .periodiccarcard .v-btn {
        padding: 0;
        min-width: 0;
        width: 100%;
        height: 100%;
    }
    .periodiccarcard .v-btn__content {
        color: #333333;
    }
    /*.periodiccarcard {*/
    /*    background-color: red;*/
    /*}*/
    /*.periodiccarcard:hover {*/
    /*    color: gray !important;*/
    /*}*/
</style>

<script>
    import tool_app from '../../utils/tool_app';
    import tool_aws from '../../utils/tool_aws';
    import model from '../../utils/model';
    import async from 'async';

    function lg (...args) { tool_app.lg('ValetReservation] ', ...args); }

    let comp = null;
    export default {
        components: { },
        props: [ 'parkinglotidx' ],
        data () {
            return {
                tool_app: tool_app,
                model: model,

                parkinglots_dialog: false,
                parkinglot_selected: {},

                edit_dialog: false,
                edit_valid: true,
                edit_new: false,
                edit_item: new model.T_ValetReservation(),
                edit_carnumber_rules: [
                    v =>
                        !!v || '입력해주세요..',
                    v => !!(comp.CarNumber_Validate(v)) || '형식이 맞지 않아요',
                ],
                edit_name_rules: [
                    v => !!v || '입력해주세요..',
                ],
                edit_address_rules: [
                    v => !!v || '입력해주세요..',
                ],
                edit_tel_rules: [
                    v => !!v || '입력해주세요..',
                ],
                edit_number_rules: [
                    v => !!v || '입력해주세요..',
                    v => !!(tool_app.isNumeric(v)) || '숫자만 입력해주세요..',
                ],
                edit_exist_rules: [
                    v => !!v || '선택해주세요..',
                ],

                parkinglots: [
                ],

                search: '',
                items_yearmonthday: [],
                DateTime_Reservation_Hour_Items: [
                    { text: '오전 8시', value: 8  },
                    { text: '오전 9시', value: 9  },
                    { text: '오전 10시', value: 10  },
                    { text: '오전 11시', value: 11  },
                    { text: '오후 12시', value: 12  },
                    { text: '오후 1시', value: 13  },
                    { text: '오후 2시', value: 14  },
                    { text: '오후 3시', value: 15  },
                    { text: '오후 4시', value: 16  },
                ],
                DateTime_Reservation_Minute_Items: [
                    { text: '0분', value: 0 },
                    { text: '10분', value: 10 },
                    { text: '20분', value: 20 },
                    { text: '30분', value: 30 },
                    { text: '40분', value: 40 },
                    { text: '50분', value: 50 },
                ],
            }
        },
        computed: {
            list: async () => {
                // lg('getList 91 value1.DateTime_Reservation_Parsed:',value1.DateTime_Reservation_Parsed);
                comp.items_yearmonthday.forEach((value, index, array) => {
                    lg('list 1 value:', tool_app.showObject(value));
                    lg('list 2 value.DateTime_Reservation_Parsed:', value.DateTime_Reservation_Parsed);
                });
                return comp.items_yearmonthday;
                // tool_app.lg('list 1 search:'+comp.search);
                // if(!comp.search) {
                //     comp.search = '';
                // }
                // let ret = [];
                // comp.items_yearmonthday.forEach((value, index, array) => {
                //     let it = tool_app.copy(value);
                //     lg('list 2 \nvalue:', tool_app.showObject(value), ' \nit:', tool_app.showObject(it));
                //     it.reservations = it.reservations.filter((value1, index1, array1) => {
                //         // if(value1.CarNumber.indexOf(comp.search) >= 0) {
                //         //     return true;
                //         // }
                //         // if(value1.Name.indexOf(comp.search) >= 0) {
                //         //     return true;
                //         // }
                //         //
                //         // return false;
                //         return true;
                //     });
                //     // if(it.reservations.length > 0) {
                //         ret.push(it);
                //     // }
                // });
                // return ret;

                // return comp.periodiccars_yearmonth.filter((value, index, array) => {
                //   if(value.yearmonthname.indexOf(comp.search) < 0) {
                //     return false;
                //   }
                //   if(value.periodiccars.length <= 0) {
                //     return false;
                //   }
                //
                //   return true;
                // });
            }
        },
        created: async function () {
            lg('created 1');
            comp = tool_app.initComp(this);
            comp.comp = this;
            comp.getList();
        },
        methods: {
            filterNumber(event) {
                let code = event.keyCode;
                if (code > 47 && code < 58) {
                    return;
                }
                if (code === 110 || code === 190) {
                    return;
                }
                if (event.ctrlKey || event.altKey) {
                    return;
                }
                if (code === 9 || code === 36 || code === 35 || code === 37 ||
                    code === 39 || code === 8 || code === 46) {
                    return;
                }
                event.preventDefault();
            },
            CarNumber_Validate(v) {
                lg('checkCarNumber 1 v:'+v);
                if(!v) {
                    return false;
                }
                if(v.length < 7) {
                    return false;
                }
                if(v.startsWith('전국') ||
                    v.startsWith('서울') ||
                    v.startsWith('경기') ||
                    v.startsWith('부산') ||
                    v.startsWith('인천') ||
                    v.startsWith('대전') ||
                    v.startsWith('대구') ||
                    v.startsWith('울산') ||
                    v.startsWith('광주') ||
                    v.startsWith('강원') ||
                    v.startsWith('충북') ||
                    v.startsWith('충남') ||
                    v.startsWith('경북') ||
                    v.startsWith('경남') ||
                    v.startsWith('전북') ||
                    v.startsWith('전남') ||
                    v.startsWith('제주')) {
                    v = v.substring(2, v.length);
                }
                if(tool_app.isNumeric(v.substring(0, 1))) {
                    if(v.length === 7) {
                        if(tool_app.isNumeric(v.substring(0, 2)) && !tool_app.isNumeric(v.substring(2, 3)) && tool_app.isNumeric(v.substring(3, 7))) {
                            return true;
                        }
                    }
                    if(v.length === 8) {
                        if(tool_app.isNumeric(v.substring(0, 3)) && !tool_app.isNumeric(v.substring(3, 4)) && tool_app.isNumeric(v.substring(4, 8))) {
                            return true;
                        }
                    }
                }
                if(v.startsWith('외교') ||
                    v.startsWith('영사') ||
                    v.startsWith('준영') ||
                    v.startsWith('준외') ||
                    v.startsWith('국기') ||
                    v.startsWith('협정') ||
                    v.startsWith('대표')) {
                    if(v.length === 8) {
                        if(tool_app.isNumeric(v.substring(2, 8))) {
                            return true;
                        }
                    }
                }

                return false;
            },
            CarNumber_Code(v) {
                if(v.startsWith('전국') ||
                    v.startsWith('서울') ||
                    v.startsWith('경기') ||
                    v.startsWith('부산') ||
                    v.startsWith('인천') ||
                    v.startsWith('대전') ||
                    v.startsWith('대구') ||
                    v.startsWith('울산') ||
                    v.startsWith('광주') ||
                    v.startsWith('강원') ||
                    v.startsWith('충북') ||
                    v.startsWith('충남') ||
                    v.startsWith('경북') ||
                    v.startsWith('경남') ||
                    v.startsWith('전북') ||
                    v.startsWith('전남') ||
                    v.startsWith('제주')) {
                    v = v.substring(2, v.length);
                }
                if(tool_app.isNumeric(v.substring(0, 1))) {
                    if(v.length === 7) {
                        return '_'+v.substring(0, 2) + '_' + v.substring(2, 3)+'_'+v.substring(3, 7);
                    }
                    if(v.length === 8) {
                        return '_'+v.substring(0, 3) + '_' + v.substring(3, 4)+'_'+v.substring(4, 8);
                    }
                }
                if(v.startsWith('외교') ||
                    v.startsWith('영사') ||
                    v.startsWith('준영') ||
                    v.startsWith('준외') ||
                    v.startsWith('국기') ||
                    v.startsWith('협정') ||
                    v.startsWith('대표')) {
                    return v.substring(0, 2) + '_' + v.substring(2, 5)+'__'+v.substring(5, 8);
                }
                return v;
            },
            async edit_item_add(item) {
                // 오전 8시 ~ 오후 4시까지만 발렛 예약 가능
                // 오전 7시에 마이발렛에 입력
                let session = await tool_aws.getCurrentSession();
                lg('edit_item_add 1 session:', session);
                let accountid = session.idToken.payload['cognito:username'];

                // // 25개 체크
                // let maxcount = 25;
                // // comp.items_yearmonthday[0].reservations.forEach((value, index, array) => {
                // item.reservations.forEach((value, index, array) => {
                //     if(value.ReservationRequesterID === accountid) {
                //         maxcount--;
                //     }
                // });
                // lg('edit_item_add 2 maxcount:', maxcount);
                // if(maxcount <= 0) {
                //     this.$dialog.alert('현재 해당일의 예약이 마감되었습니다. 이용에 불편드려 죄송합니다.');
                //     return;
                // }

                // // 2019.12.09 계정당 1일 2개 체크
                // let maxcount = 2;
                // // comp.items_yearmonthday[0].reservations.forEach((value, index, array) => {
                // item.reservations.forEach((value, index, array) => {
                //     if(value.ReservationRequesterID === accountid) {
                //         maxcount--;
                //     }
                // });
                // lg('edit_item_add 2 maxcount:', maxcount);
                // if(maxcount <= 0) {
                //     comp.$dialog.alert('현재 해당일의 예약이 마감되었습니다. 이용에 불편드려 죄송합니다.');
                //     return;
                // }

                // 2019.12.12 총 1일 20개 체크
                let maxcount_total = 20;
                // 2019.12.09 계정당 1일 2개 체크
                let maxcount = 2;
                // comp.items_yearmonthday[0].reservations.forEach((value, index, array) => {
                item.reservations.forEach((value, index, array) => {
                    if(value.ReservationRequesterID === accountid) {
                        maxcount--;
                    }
                    maxcount_total--;
                });
                lg('edit_item_add 2 maxcount:', maxcount);
                if(maxcount <= 0 || maxcount_total <= 0) {
                    comp.$dialog.alert('현재 해당일의 예약이 마감되었습니다. 이용에 불편드려 죄송합니다.');
                    return;
                }

                comp.periodiccars_yearmonth_item_selected = item;

                comp.edit_valid = true;
                comp.edit_new = true;

                comp.edit_item = new model.T_ValetReservation();

                // let now = new Date();
                // let nextday = null;
                // if(now.getDay() === 5) {
                //     nextday = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
                // }
                // else if(now.getDay() >= 1 && now.getDay() <= 4) {
                //     nextday = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                // }
                lg('edit_item_add 2 nextday: '+(typeof item.adddate)+' ' + item.adddate);
                // comp.edit_item.DateTime_Reservation = new Date(nextday);
                comp.edit_item.DateTime_Reservation = new Date(item.adddate);
                comp.edit_item.DateTime_Reservation_Month = comp.edit_item.DateTime_Reservation.getMonth()+1;
                comp.edit_item.DateTime_Reservation_Date = comp.edit_item.DateTime_Reservation.getDate();
                // if(comp.edit_item.DateTime_Reservation.getHours() <= 11) {
                //     comp.edit_item.DateTime_Reservation_AMPM = 'AM';
                // }
                // else {
                //     comp.edit_item.DateTime_Reservation_AMPM = 'PM';
                // }
                // comp.edit_item.DateTime_Reservation_Hour = (comp.edit_item.DateTime_Reservation.getHours() - 1) % 12 + 1;
                comp.edit_item.DateTime_Reservation_Hour = comp.edit_item.DateTime_Reservation.getHours();
                comp.edit_item.DateTime_Reservation_Minute = Math.round(comp.edit_item.DateTime_Reservation.getMinutes() / 10) * 10;

                // let accountid = session.idToken.payload['cognito:username'];
                // comp.edit_item.ReservationRequesterCompany = '미래에셋';
                comp.edit_item.ReservationRequesterCompany = session.idToken.payload['custom:description'];
                comp.edit_item.ReservationRequesterID = accountid;
                comp.edit_item.ReservationRequesterName = comp.$cookies.get(model.cookies.accountname);
                comp.edit_item.ReservationRequesterTel = comp.$cookies.get(model.cookies.accounttel);
                if(! comp.edit_item.ReservationRequesterTel) {
                    comp.edit_item.ReservationRequesterTel = '';
                }

                comp.edit_dialog = true;
            },
            async edit_item_modify(item) {
                lg('edit_item_modify 1 item:', item);
                comp.edit_valid = true;
                comp.edit_new = false;
                comp.edit_item_old = tool_app.copy(item);
                comp.edit_item = tool_app.copy(item);

                comp.edit_item.DateTime_Reservation = new Date(comp.edit_item.DateTime_Reservation);
                comp.edit_item.DateTime_Reservation_Month = comp.edit_item.DateTime_Reservation.getMonth()+1;
                comp.edit_item.DateTime_Reservation_Date = comp.edit_item.DateTime_Reservation.getDate();
                // if(comp.edit_item.DateTime_Reservation.getHours() <= 11) {
                //     comp.edit_item.DateTime_Reservation_AMPM = 'AM';
                // }
                // else {
                //     comp.edit_item.DateTime_Reservation_AMPM = 'PM';
                // }
                // comp.edit_item.DateTime_Reservation_Hour = (comp.edit_item.DateTime_Reservation.getHours() - 1) % 12 + 1;
                comp.edit_item.DateTime_Reservation_Hour = comp.edit_item.DateTime_Reservation.getHours();
                comp.edit_item.DateTime_Reservation_Minute = Math.round(comp.edit_item.DateTime_Reservation.getMinutes() / 10) * 10;

                comp.edit_dialog = true;
            },
            async edit_item_delete(item) {
                lg('edit_item_delete 1 item:', item);
                let d = comp.$dialog.confirm(item.CarNumber + '을 정말 삭제하시겠습니까?');
                d.then(async (dialog) => {
                    lg('item_delete confirm');

                    tool_app.api(this,`
                        UPDATE myvalet_reservation.T_ValetReservation
                        SET IsExist = false
                        WHERE ValetReservationIDX = ?
                    `, [ item.ValetReservationIDX, ])
                        .setShowProgressDialog()
                        .send()
                        .then((value) => {
                            lg('item_delete 3 value:', value);

                            comp.getList();
                        })
                        .catch((reason) => {
                            tool_app.ex(reason);
                            this.$dialog.alert(JSON.stringify(reason, null, 2));
                        });
                });
            },
            async edit_submit() {
                lg('edit_submit 1 ');
                if (comp.edit_dialog && comp.$refs.edit_form.validate()) {
                    let session = await tool_aws.getCurrentSession();
                    lg('edit_item_add 1 session:', session);
                    let accountid = session.idToken.payload['cognito:username'];

                    // 2019.12.12 총 1일 20개 체크
                    let maxcount_total = 20;
                    // 2019.12.09 계정당 1일 2개 체크
                    let maxcount = 2;
                    // comp.items_yearmonthday[0].reservations.forEach((value, index, array) => {
                    comp.periodiccars_yearmonth_item_selected.reservations.forEach((value, index, array) => {
                        if(value.ReservationRequesterID === accountid) {
                            maxcount--;
                        }
                        maxcount_total--;
                    });
                    lg('edit_item_add 2 maxcount:', maxcount);
                    if(maxcount <= 0 || maxcount_total <= 0) {
                        comp.$dialog.alert('현재 해당일의 예약이 마감되었습니다. 이용에 불편드려 죄송합니다.');
                        return;
                    }

                    lg('edit_submit 2 this.edit_dialog:', comp.edit_item.Name);
                    comp.$cookies.set(model.cookies.accounttel, comp.edit_item.ReservationRequesterTel);

                    // comp.edit_item.DateTime_Reservation.setDate(comp.edit_item.DateTime_Reservation_Date);
                    // if(comp.edit_item.DateTime_Reservation_AMPM === 'AM') {
                    //     if(comp.edit_item.DateTime_Reservation_Hour === 12) {
                    //         comp.edit_item.DateTime_Reservation.setHours(0);
                    //     }
                    //     else {
                    //         comp.edit_item.DateTime_Reservation.setHours(comp.edit_item.DateTime_Reservation_Hour);
                    //     }
                    // }
                    // else {
                    //     if(comp.edit_item.DateTime_Reservation_Hour === 12) {
                    //         comp.edit_item.DateTime_Reservation.setHours(12);
                    //     }
                    //     else {
                    //         comp.edit_item.DateTime_Reservation.setHours(comp.edit_item.DateTime_Reservation_Hour + 12);
                    //     }
                    // }
                    comp.edit_item.DateTime_Reservation.setHours(comp.edit_item.DateTime_Reservation_Hour);
                    comp.edit_item.DateTime_Reservation.setMinutes(comp.edit_item.DateTime_Reservation_Minute);
                    comp.edit_item.DateTime_Reservation.setSeconds(0);

                    if(comp.edit_new) {
                        tool_app.api(comp, `
                            INSERT INTO myvalet_reservation.T_ValetReservation
                            (IsExist, DateTime_Created, DateTime_Modified,
                             CarNumber, CarModel, DateTime_Reservation, CarOwnerName, CarOwnerTel,
                             ReservationRequesterCompany, ReservationRequesterID, ReservationRequesterName, ReservationRequesterTel)
                            VALUES
                            (true, NOW(), NOW(),
                             ?, ?, ?, ?, ?,
                             ?, ?, ?, ?)
                        `, [
                            comp.CarNumber_Code(comp.edit_item.CarNumber), comp.edit_item.CarModel, comp.edit_item.DateTime_Reservation, comp.edit_item.CarOwnerName, comp.edit_item.CarOwnerTel,
                            comp.edit_item.ReservationRequesterCompany, comp.edit_item.ReservationRequesterID, comp.edit_item.ReservationRequesterName, comp.edit_item.ReservationRequesterTel, ])
                            .setShowProgressDialog()
                            .send()
                            .then(async (value) => {
                                lg('edit_submit 3 value:', value);
                                lg('edit_submit 4 value.data.results.insertId:', value.data.results.insertId);

                                comp.edit_dialog = false;
                                comp.getList();
                            })
                            .catch((reason) => {
                                tool_app.ex(reason);
                                comp.$dialog.alert(JSON.stringify(reason, null, 2));
                            });
                    }
                    else {
                        tool_app.api(this,`
                            UPDATE myvalet_reservation.T_ValetReservation
                            SET DateTime_Modified = NOW(),
                                CarNumber = ?, CarModel = ?, DateTime_Reservation = ?, CarOwnerName = ?, CarOwnerTel = ?,
                                ReservationRequesterCompany = ?, ReservationRequesterID = ?, ReservationRequesterName = ?, ReservationRequesterTel = ?
                            WHERE ValetReservationIDX = ?
                        `, [
                            comp.CarNumber_Code(comp.edit_item.CarNumber), comp.edit_item.CarModel, comp.edit_item.DateTime_Reservation, comp.edit_item.CarOwnerName, comp.edit_item.CarOwnerTel,
                            comp.edit_item.ReservationRequesterCompany, comp.edit_item.ReservationRequesterID, comp.edit_item.ReservationRequesterName, comp.edit_item.ReservationRequesterTel,
                            comp.edit_item.ValetReservationIDX
                        ])
                            .setShowProgressDialog()
                            .send()
                            .then((value) => {
                                lg('edit_submit 3 value:', value);

                                comp.edit_dialog = false;
                                comp.getList();
                            })
                            .catch((reason) => {
                                tool_app.ex(reason);
                                comp.$dialog.alert(JSON.stringify(reason, null, 2));
                            });
                    }
                }
            },

            listupdatetime: 0,
            async getList() {
                let now = new Date().getTime();
                if(now - 2000 <= comp.listupdatetime && comp.listupdatetime <= now + 2000) {
                    return;
                }
                lg('getList 1 ', comp.parkinglot_selected);
                let session = await tool_aws.getCurrentSession();
                lg('edit_item_add 1 session:', session);
                let accountid = session.idToken.payload['cognito:username'];

                async.parallel([
                    function(callback) {
                        lg('getList 22 1');
                        let api = null;
                        api = tool_app.api(comp, `
                                        SELECT r.*
                                        FROM myvalet_reservation.T_ValetReservation r
                                        WHERE r.IsExist = true
                                          AND r.DateTime_Reservation >= DATE_SUB(NOW(), INTERVAL 2 MONTH)
                                        ORDER BY r.DateTime_Reservation DESC
                                    `,
                            [ ])
                            .send();
                        // if(tool_app.isAdmin()) {
                        //     api = tool_app.api(comp, `
                        //                 SELECT r.*
                        //                 FROM myvalet_reservation.T_ValetReservation r
                        //                 WHERE r.IsExist = true
                        //                   AND r.DateTime_Reservation >= DATE_SUB(NOW(), INTERVAL 2 MONTH)
                        //                 ORDER BY r.DateTime_Reservation DESC
                        //             `,
                        //         [ ])
                        //         .send();
                        // }
                        // else {
                        //     api = tool_app.api(comp, `
                        //                 SELECT r.*
                        //                 FROM myvalet_reservation.T_ValetReservation r
                        //                 WHERE r.IsExist = true
                        //                   AND r.ReservationRequesterID = ?
                        //                   AND r.DateTime_Reservation >= DATE_SUB(NOW(), INTERVAL 2 MONTH)
                        //                 ORDER BY r.DateTime_Reservation DESC
                        //             `,
                        //         [ accountid, ])
                        //         .send();
                        // }
                    api.then((value) => {
                            lg('getList 22 2 value:', value.data.results);
                            callback(null, value.data.results);
                        })
                            .catch((reason) => {
                                let err = new Error(JSON.stringify(reason, null, 2));
                                tool_app.ex(err);
                                callback(err, null);
                            });
                    },
                ], async (err, results) => {
                    try {
                        lg('getList 91 err:',err,' results:',results);
                        comp.items_yearmonthday = [];
                        if(err) {
                            tool_app.ex(err);
                            return;
                        }
                        let now = new Date();
                        for(let di = 7;di >= 1; di--) {
                            let nextday = new Date(now.getTime() + di * 24 * 60 * 60 * 1000);
                            if(nextday.getDay() === 0 || nextday.getDay() === 6) {
                                continue;
                            }
                            // if(now.getDay() === 5) {
                            //     nextday = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
                            // }
                            // else if(now.getDay() >= 1 && now.getDay() <= 4) {
                            //     nextday = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                            // }
                            // if(nextday !== null)  {
                            nextday.setHours(9);
                            nextday.setMinutes(0);
                            nextday.setSeconds(0);
                            nextday.setMilliseconds(0);
                            // 주말에는 발렛 예약 안 받음
                            lg('getList 99 nextday.getDay():', nextday.getDay());
                            let value1 = {
                                DateTime_Reservation_Parsed: nextday,
                            };
                            value1.yearmonthday = value1.DateTime_Reservation_Parsed.getFullYear()+tool_app.padzero(value1.DateTime_Reservation_Parsed.getMonth()+1, 2)+tool_app.padzero(value1.DateTime_Reservation_Parsed.getDate(), 2);
                            let pym = {
                                yearmonthday: value1.yearmonthday,
                                yearmonthname: value1.DateTime_Reservation_Parsed.getFullYear() + '년 ' + (value1.DateTime_Reservation_Parsed.getMonth()+1)+ '월 '+ (value1.DateTime_Reservation_Parsed.getDate())+'일 ('+ (tool_app.dateformat(value1.DateTime_Reservation_Parsed, 'dd'))+')',
                                showadd: true,
                                adddate: nextday,
                                reservations: [],
                            };
                            lg('getList 99 nextday.getDay():', nextday.getDay());
                            comp.items_yearmonthday.push(pym);
                        }

                        results[0].forEach(async (value1, index, array) => {
                            let pym = null;
                            value1.CarNumber = value1.CarNumber.replace(/_/gi,"");
                            value1.DateTime_Reservation_Parsed = new Date(value1.DateTime_Reservation);
                            value1.DateTime_Reservation_Desc = tool_app.padzero(value1.DateTime_Reservation_Parsed.getHours(), 2)+':'+tool_app.padzero(value1.DateTime_Reservation_Parsed.getMinutes(), 2);
                            lg('getList 91 value1.DateTime_Reservation_Parsed:',value1.DateTime_Reservation_Parsed);
                            value1.yearmonthday = value1.DateTime_Reservation_Parsed.getFullYear()+tool_app.padzero(value1.DateTime_Reservation_Parsed.getMonth()+1, 2)+tool_app.padzero(value1.DateTime_Reservation_Parsed.getDate(), 2);
                            comp.items_yearmonthday.forEach((value2, index1, array1) => {
                                if(value2.yearmonthday === value1.yearmonthday) {
                                    pym = value2;
                                }
                            });
                            if(pym === null) {
                                pym = {
                                    yearmonthday: value1.yearmonthday,
                                    // yearmonthname: value1.DateTime_Reservation_Parsed.getFullYear() + '년 ' + (value1.DateTime_Reservation_Parsed.getMonth()+1)+ '월 '+ (value1.DateTime_Reservation_Parsed.getDate())+'일',
                                    yearmonthname: value1.DateTime_Reservation_Parsed.getFullYear() + '년 ' + (value1.DateTime_Reservation_Parsed.getMonth()+1)+ '월 '+ (value1.DateTime_Reservation_Parsed.getDate())+'일 ('+ (tool_app.dateformat(value1.DateTime_Reservation_Parsed, 'dd'))+')',
                                    showadd: false,
                                    reservations: [],
                                };
                                comp.items_yearmonthday.push(pym);
                            }
                            // 당일것도 수정/삭제 제외 내일것만
                            // if(value1.DateTime_Reservation_Parsed.getTime() >= new Date(new Date().getTime() - 60 * 60 * 1000)) {
                            value1.showmod = false;
                            // if(value1.DateTime_Reservation_Parsed.getTime() >= nextday.getTime()) {
                            if(pym.showadd) {
                                let session = await tool_aws.getCurrentSession();
                                lg('edit_item_add 1 session:', session);
                                let accountid = session.idToken.payload['cognito:username'];

                                if(value1.ReservationRequesterID === accountid) {
                                    value1.showmod = true;
                                }
                            }
                            pym.reservations.push(value1);
                        });
                    }
                    catch (e) {
                        tool_app.ex(e);
                    }
                });
            },
        }
    }
</script>
